var preUrl = "/api";
import store from '../../store'
import bus from './bus';
import cookie from './cookie';
import {Message, Loading} from 'element-ui';

let loadingInstance;

let needLoadingRequestCount = 0;
let hiddenLoading=false;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0 && !hiddenLoading) {
    //loading开始
    loadingInstance = Loading.service({ fullscreen: true });
  }
  needLoadingRequestCount++
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0 &&loadingInstance!=undefined && !hiddenLoading) {
    // loading结束
    loadingInstance.close();
  }
  hiddenLoading=false;
}


function httpRequest(_this, url, params, success, failed, error) {
  //兼容url
  url = preUrl + url;
  showFullScreenLoading();
  _this.$http.post(url, params).then(function (response) {
    tryHideFullScreenLoading();
    var resultCode = response.data.resultCode;
    if (resultCode === "0") {
      success(response);
    } else {
      if (resultCode === "15030003") {
        store.commit('logoutSuccess');
        cookie.clearCookie("userToken");
        _this.$router.push({path: "/login"});
      } else {
        if (failed !== null && failed !== undefined) {
          //页面接收失败并处理
          failed(response);
        } else {
          //统一处理请求失败
          this.$message.error(response.data.result);
        }
      }
    }
  }, function (response) {
    tryHideFullScreenLoading();
    //http请求失败处理
    if (error !== null && error !== undefined) {
      //不需要跳转错误页
      if (failed !== null && failed !== undefined) {
        var res = {data: {result: "服务器异常，请稍后再试！"}};
        failed(res);
      }
    } else {
      //TODO:暂时注释掉统一的错误页面,方便调试
      //_this.$route.router.go({path: "/error"});
    }
  });
}

module.exports = {
  //////////////////////用户模块接口 begin/////////////////////
  //修改密码
  'changePassword': function (_this, params, success, failed) {
    httpRequest(_this, '/user/changePassword', params, success, failed);
  },
  //修改账号
  'changeAccountName': function (_this, params, success, failed) {
    httpRequest(_this, '/user/changeAccountName', params, success, failed);
  },
  //分账返回的html
  'doPay': function (_this, params, success, failed) {
    httpRequest(_this, '/adapay/doPay', params, success, failed);
  },
  //////////////////////用户模块接口 end/////////////////////

  //////////////////////公共模块接口 begin/////////////////////
  //1-城市列表
  'cityList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/cityList', params, success, failed);
  },
  //3-城市片区列表
  'cityAreaList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/cityAreaList', params, success, failed);
  },
  //3-地铁列表
  'metroList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/metroList', params, success, failed);
  },
  //2-区域列表
  'districtList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/districtList', params, success, failed);
  },
  //3-上传图片
  'uploadImage': function (_this, params, success, failed) {
    httpRequest(_this, '/public/uploadImage', params, success, failed);
  },
  //3-图片增加标签
  'imageAddTag': function (_this, params, success, failed) {
    httpRequest(_this, '/public/imageAddTag', params, success, failed);
  },
  //4-短信验证码
  'getSMSCode': function (_this, params, success, failed) {
    httpRequest(_this, '/public/getSMSCode', params, success, failed);
  },
  'getSMSCodePic': function (_this, params, success, failed) {
    httpRequest(_this, '/common/validateCode', params, success, failed);
  },
  //5-实名认证
  'approveIDCard': function (_this, params, success, failed) {
    httpRequest(_this, '/public/approveIDCard', params, success, failed);
  },
  //6-获取运营商信息
  'operatorDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/public/operatorDetail', params, success, failed);
  },
  //7-修改运营商信息
  'updateOperator': function (_this, params, success, failed) {
    httpRequest(_this, '/public/updateOperator', params, success, failed);
  },
  //8-基础设施列表
  'facilitiesList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/facilitiesList', params, success, failed);
  },
  //9-基础费用项列表
  'tenementFeeList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/tenementFeeList', params, success, failed);
  },
  //10-运营商小区列表
  'operatorResidentialAreaList': function (_this, params, success, failed) {
    httpRequest(_this, '/public/operatorResidentialAreaList', params, success, failed);
  },
  'operatorResidentialAreaListPlus': function (_this, params, success, failed) {
    httpRequest(_this, '/public/operatorResidentialAreaListPlus', params, success, failed);
  },

  //////////////////////公共组件接口 end/////////////////////

  //////////////////////集中式房源模块接口 begin/////////////////////
  //0-集中式房间统计
  'apartmentRoomStatistic': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomStatistic', params, success, failed);
  },
  //0-轻量版公寓列表
  'busiApartmentList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/busiApartmentList', params, success, failed);
  },
  //1-房态图列表
  'apartmentRoomStatePicList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomStatePicList', params, success, failed);
  },
  //2-房间状态列表
  'apartmentRoomStateList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomStateList', params, success, failed);
  },
  //3-公寓列表
  'apartmentList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentList', params, success, failed);
  },
  //4-公寓详情
  'apartmentDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentDetail', params, success, failed);
  },
  //5-新增/修改公寓
  'saveOrUpdateApartment': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/saveOrUpdateApartment', params, success, failed);
  },
  //6-公寓楼层列表
  'apartmentFloorList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentFloorList', params, success, failed);
  },
  //7-新增楼层
  'addApartmentFloor': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/addApartmentFloor', params, success, failed);
  },
  //8-更新楼层
  'updateApartmentFloor': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/updateApartmentFloor', params, success, failed);
  },
  //9-删除楼层
  'deleteApartmentFloor': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/deleteApartmentFloor', params, success, failed);
  },
  //10-上架公寓
  'onSaleApartment': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/onSaleApartment', params, success, failed);
  },
  //10-上架公寓批量
  'onSaleApartmentRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/onSaleApartmentRoom', params, success, failed);
  },
  //11-下架公寓
  'offSaleApartment': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/offSaleApartment', params, success, failed);
  },
  //11-下架公寓批量
  'offSaleApartmentRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/offSaleApartmentRoom', params, success, failed);
  },
  //12-房型列表
  'apartmentRoomModelList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomModelList', params, success, failed);
  },
  //13-房型详情
  'apartmentRoomModelDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomModelDetail', params, success, failed);
  },
  //14-新增/修改房型
  'saveOrUpdateApartmentRoomModel': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/saveOrUpdateApartmentRoomModel', params, success, failed);
  },
  //15-删除房型
  'deleteApartmentRoomModel': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/deleteApartmentRoomModel', params, success, failed);
  },
  //16-新增/修改房间
  'saveOrUpdateApartmentRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/saveOrUpdateApartmentRoom', params, success, failed);
  },
  //17-删除房间
  'deleteApartmentRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/deleteApartmentRoom', params, success, failed);
  },
  //18-房间列表
  'apartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomList', params, success, failed);
  },
  //19-房间详情
  'apartmentRoomDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentRoomDetail', params, success, failed);
  },
  //20-批量导入房间
  'importApartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/importApartmentRoomList', params, success, failed);
  },
  //21-公寓费用项列表
  'apartmentTenementFeeList': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/apartmentTenementFeeList', params, success, failed);
  },
  //22-下载导入房源模板
  'importApartmentRoomExcel': function () {
    return preUrl + "/apartment/importApartmentRoomExcel";
  },
  //23-同步房型图片设施到房间
  'syncRoomModelToRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartment/syncRoomModelToRoom', params, success, failed);
  },
  //////////////////////集中式房源模块接口 end/////////////////////



  //////////////////////分散式房源模块接口 begin/////////////////////
  //房源列表
  'residentialHouseList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residentialHouseList', params, success, failed);
  },
  //房态图列表
  'residenceHouseStatePicList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residenceHouseStatePicList', params, success, failed);
  },
  //房态图快速列表
  'residenceHouseStatePicListQuick': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residenceHouseStatePicListQuick', params, success, failed);
  },
  //分散式房间统计
  'residenceRoomStatistic': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residenceRoomStatistic', params, success, failed);
  },
  //房源详情
  'residentialHouseDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residentialHouseDetail', params, success, failed);
  },
  //新增/修改房源
  'saveOrUpdateResidentialHouse': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/saveOrUpdateResidentialHouse', params, success, failed);
  },
  //删除房源
  'deleteResidentialHouse': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/deleteResidentialHouse', params, success, failed);
  },
  //房间列表
  'ResApartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/apartmentRoomList', params, success, failed);
  },
  //修改房间列表
  'updateApartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/updateApartmentRoomList', params, success, failed);
  },
  //已退租约列
  'evictioncontractlist': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/evictionContractList', params, success, failed);
  },
  //导出已退租约列表
  'exportevictioncontractlist': function () {
    return preUrl + "/residence/exportEvictionContractList";
  },

  //1-房源列表
  'houseList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/houseList', params, success, failed);
  },
  //2-简版房源列表
  'briefHouseList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/briefHouseList', params, success, failed);
  },
  //3-简版房间列表
  'briefApartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/briefApartmentRoomList', params, success, failed);
  },
  //4-房源详情
  'residenceApartmentDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/apartmentDetail', params, success, failed);
  },
  //5-新增/修改房源
  'saveOrUpdateResidenceApartment': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/saveOrUpdateApartment', params, success, failed);
  },
  //6-删除房源
  'deleteResidenceApartment': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/deleteApartment', params, success, failed);
  },
  //7-房间列表
  'residenceApartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/apartmentRoomList', params, success, failed);
  },
  //8-修改房间列表
  'updateResidenceApartmentRoomList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/updateApartmentRoomList', params, success, failed);
  },
  //9-房间详情
  'residenceApartmentRoomDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/apartmentRoomDetail', params, success, failed);
  },
  //10-修改房间
  'updateResidenceApartmentRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/updateApartmentRoom', params, success, failed);
  },
  //11-分散式房间费用项列表
  'residenceRoomFeeList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residenceRoomFeeList', params, success, failed);
  },
  //有租约小区列表
  'residentialAreaListWithContract': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residentialAreaListWithContract', params, success, failed);
  },
  //有租约房源列表
  'residenceHouseListWithContract': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residenceHouseListWithContract', params, success, failed);
  },
  //有租约房间列表
  'residenceRoomListWithContract': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/residenceRoomListWithContract', params, success, failed);
  },
  //完成装修
  'finishedDecoration': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/finishedDecoration', params, success, failed);
  },
  //带看记录列表
  'lookathouselist': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/lookAtHouseList', params, success, failed);
  },
  //带看记录详情
  'lookathousedetail': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/lookAtHouseDetail', params, success, failed);
  },
  //带看记录统计
  'lookathousestatistic': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/lookAtHouseStatistic', params, success, failed);
  },
  //导出带看记录列表
  'exportlookathouselist': function () {
    return preUrl + "/residence/exportLookAtHouseList";
  },
  //历史租约列表
  'historycontractlist': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/historyContractList', params, success, failed);
  },
  //修改历史租约备注
  'modifyhistorycontractremark': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/modifyHistoryContractRemark', params, success, failed);
  },
  //出租率续租率列表
  'occupancyrenewalratelist': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/occupancyRenewalRateList', params, success, failed);
  },
  //新增巡房记录
  'saveorupdatepatrolrecords': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/saveOrUpdatePatrolRecords', params, success, failed);
  },
  //巡房记录列表
  'patrolrecordslist': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/patrolRecordsList', params, success, failed);
  },
  //巡房记录详情
  'patrolrecordsdetail': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/patrolRecordsDetail', params, success, failed);
  },
  //审核巡房记录
  'approvepatrolrecords': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/approvePatrolRecords', params, success, failed);
  },
  //巡房记录统计
  'patrolrecordsstatistic': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/patrolRecordsStatistic', params, success, failed);
  },
  //导出巡房记录列表
  'exportpatrolrecordslist': function () {
    return preUrl + "/residence/exportPatrolRecordsList";
  },
  //////////////////////分散式房源模块接口 end/////////////////////



  //////////////////////门店模块接口/////////////////////
  //1-门店列表
  'storelist': function (_this, params, success, failed) {
    httpRequest(_this, '/store/storeList', params, success, failed);
  },
  //2-新建/修改门店
  'saveorupdatestore': function (_this, params, success, failed) {
    httpRequest(_this, '/store/saveOrUpdateStore', params, success, failed);
  },
  //3-门店名称列表
  'storenamelist': function (_this, params, success, failed) {
    httpRequest(_this, '/store/storeNameList', params, success, failed);
  },
  //4-门店收房统计
  'storebusiness': function (_this, params, success, failed) {
    httpRequest(_this, '/store/storeBusiness', params, success, failed);
  },


  //////////////////////工单模块接口 begin/////////////////////
  //1-新建工单
  'addWorksheet': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/addWorksheet', params, success, failed);
  },
  //2-工单列表
  'worksheetList': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/worksheetList', params, success, failed);
  },
  //3工单详情
  'worksheetDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/worksheetDetail', params, success, failed);
  },
  //4-接单
  'receiveWorksheet': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/receiveWorksheet', params, success, failed);
  },
  //5-完成工单
  'finishWorksheet': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/finishWorksheet', params, success, failed);
  },
  //6-添加工单日志
  'addWorksheetLog': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/addWorksheetLog', params, success, failed);
  },
  //7-导出工单列表
  'exportworksheetlist': function () {
    return preUrl + "/worksheet/exportWorksheetList";
  },
  //8-审批工单
  'approveworksheet': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/approveWorksheet', params, success, failed);
  },
  //9-派单
  'appointworksheet': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/appointWorksheet', params, success, failed);
  },
  //10-平均评星
  'getAverageStar': function (_this, params, success, failed) {
    httpRequest(_this, '/worksheet/getAverageStar', params, success, failed);
  },
  //////////////////////工单模块接口 end/////////////////////

  //////////////////////合同模块接口 begin/////////////////////
  //1-创建/编辑租约
  'saveOrUpdateTenementContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/saveOrUpdateTenementContract', params, success, failed);
  },
  //2-租约详情
  'tenementContractDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/tenementContractDetail', params, success, failed);
  },
  //3-无租约出租
  'leaseWithoutContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/leaseWithoutContract', params, success, failed);
  },
  //4-无租约退租
  'cancelLeaseWithoutContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/cancelLeaseWithoutContract', params, success, failed);
  },
  //5-退租
  'evictionContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/evictionContract', params, success, failed);
  },
  //6-续租
  'reletContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/reletContract', params, success, failed);
  },
  //7-换房
  'exchangeRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/exchangeRoom', params, success, failed);
  },
  //8-房间操作日志列表
  'apartmentRoomTraceList': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/apartmentRoomTraceList', params, success, failed);
  },
  //9-下载退租单
  'evictionContractExport': function () {
    return preUrl + "/contract/evictionContractExport";
  },
  //10-下载租约
  'contractExport': function () {
    return preUrl + "/contract/contractExport";
  },
  //废弃租约
  'closeContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/closeContract', params, success, failed);
  },
  //审核租约
  'approveContract': function (_this, params, success, failed) {
    httpRequest(_this, '/contract/approveContract', params, success, failed);
  },
  //////////////////////合同模块接口 end/////////////////////

  //////////////////////账单管理接口 begin/////////////////////
  //1-手工账单列表
  'manualOrderList': function (_this, params, success, failed) {
    httpRequest(_this, '/order/manualOrderList', params, success, failed);
  },
  //2-手工账单详情
  'manualOrderDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/order/manualOrderDetail', params, success, failed);
  },
  //3-新建手工账单
  'addManualOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/addManualOrder', params, success, failed);
  },
  //4-导出手工账单列表
  'exportManualOrderList': function () {
    return preUrl + "/order/exportManualOrderList";
  },
  //5-编辑账单
  'editTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/editTenementOrder', params, success, failed);
  },
  //6-账单列表
  'tenementOrderList': function (_this, params, success, failed) {
    httpRequest(_this, '/order/tenementOrderList', params, success, failed);
  },
  //7-账单详情
  'tenementOrderDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/order/tenementOrderDetail', params, success, failed);
  },
  //8-账单记账
  'accountTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/accountTenementOrder', params, success, failed);
  },
  //9-创建账单 收租/收费单(createOrder)
  'createTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/createTenementOrder', params, success, failed);
  },
  //10-关闭订单
  'closeTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/closeTenementOrder', params, success, failed);
  },
  //11-催收
  'noticePay': function (_this, params, success, failed) {
    httpRequest(_this, '/order/noticePay', params, success, failed);
  },
  //12-合并账单
  'mergeTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/mergeTenementOrder', params, success, failed);
  },
  //13-恢复拆分过的账单
  'recoveryTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/recoveryTenementOrder', params, success, failed);
  },
  //14-拆分账单
  'splitTenementOrder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/splitTenementOrder', params, success, failed);
  },
  //15-导出账单列表
  'exportTenementOrderList': function () {
    return preUrl + "/order/exportTenementOrderList";
  },
  //16-下载导入费用模板
  'importApartmentFeeExcel': function () {
    return preUrl + "/order/importApartmentFeeExcel";
  },
  //17-账单打印信息excel
  'printOrderExcelExport': function () {
    return preUrl + "/order/printOrderExcelExport";
  },
  //18-导出交易明细列表
  'exportExchangeOrderList': function () {
    return preUrl + "/order/exportExchangeOrderList";
  },
  //19-子账单拆分账单
  'splitsubtenementorder': function (_this, params, success, failed) {
    httpRequest(_this, '/order/splitSubTenementOrder', params, success, failed);
  },
  //编辑账单支付凭证(BOOL)
  'editOrderVoucher': function (_this, params, success, failed) {
    httpRequest(_this, '/order/editOrderVoucher', params, success, failed);
  },
  //调整账单可见状态
  'changetenementordervisiable': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementOrder/changeTenementOrderVisiable', params, success, failed);
  },
  //手动添加一期账单
  'createorder': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementOrder/createOrder', params, success, failed);
  },
  //////////////////////账单管理接口 end/////////////////////

  //////////////////////财务管理接口 begin/////////////////////
  //1-公寓账单列表
  'apartmentBillList': function (_this, params, success, failed) {
    httpRequest(_this, '/finance/apartmentBillList', params, success, failed);
  },
  //2-公寓结算信息
  'apartmentSettlementInfo': function (_this, params, success, failed) {
    httpRequest(_this, '/finance/apartmentSettlementInfo', params, success, failed);
  },
  //3-提现列表
  'recordList': function (_this, params, success, failed) {
    httpRequest(_this, '/finance/recordList', params, success, failed);
  },
  //4-下载公寓结算交易/提现清单
  'exportSettlement': function () {
    return preUrl + "/finance/exportSettlement";
  },
  //5-下载公寓交易结算单
  'exportSettlementBill': function () {
    return preUrl + "/finance/exportSettlementBill";
  },
  //6-账单费用类型列表
  'orderFeeTypeList': function (_this, params, success, failed) {
    httpRequest(_this, '/finance/orderFeeTypeList', params, success, failed);
  },
  //7-账单费用列表
  'orderFeeList': function (_this, params, success, failed) {
    httpRequest(_this, '/finance/orderFeeList', params, success, failed);
  },
  //8-账单明细列表导出
  'exportOrderDetailList': function () {
    return preUrl + "/finance/exportOrderDetailList";
  },
  //////////////////////财务管理接口 end/////////////////////

  //////////////////////微店管理接口 begin/////////////////////
  //创建微店
  'addWeixinMp': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/addWeixinMp', params, success, failed);
  },
  //微店基础信息列表
  'weixinMpList': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/weixinMpList', params, success, failed);
  },
  //微信授权
  'authWeixinMp': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/authWeixinMp', params, success, failed);
  },
  //下载二维码
  'downloadQRCode': function () {
    return preUrl + "/weixin/downloadQRCode";
  },
  //活动列表
  'apartmentActivityList': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/apartmentActivityList', params, success, failed);
  },
  //用户优惠券列表
  'userCouponList': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/userCouponList', params, success, failed);
  },
  //发放优惠券记录
  'sendcouponrecords':function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/getSendCouponRecordList', params, success, failed);
  },
  //新建,更新活动
  'saveOrUpdateApartmentActivity': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/saveOrUpdateApartmentActivity', params, success, failed);
  },
  //房间模板列表(Pager)
  'roomModelList' : function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/roomModelList', params, success, failed);
  },
  //房间模板详情(RoomModel)
  'roomModelDetail' : function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/roomModelDetail', params, success, failed);
  },
  //新增/修改房间模板
  'saveOrUpdateRoomModel' : function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/saveOrUpdateRoomModel', params, success, failed);
  },
  //删除房间模板(Bool)
  'deleteRoomModel' : function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/deleteRoomModel', params, success, failed);
  },
  //新建,更新微信菜单项
  'updateWeixinMpMenu': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/updateWeixinMpMenu', params, success, failed);
  },
  //微信账单发送时间操作
  'configOperatorSetting': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/configOperatorSetting', params, success, failed);
  },
  'operatorSetting': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/operatorSetting', params, success, failed);
  },
  'notificationDescDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/notificationDescDetail', params, success, failed);
  },
  'saveOrUpdateNotificationDesc': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/saveOrUpdateNotificationDesc', params, success, failed);
  },
  //分散式优惠券列表
  'getResidenceCouponList': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/getResidenceCouponList', params, success, failed);
  },
  //创建/修改优惠券
  'saveOrUpdateResidenceCoupon': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/saveOrUpdateResidenceCoupon', params, success, failed);
  },
  //手动发放优惠券
  'manualDistributionUserCoupon': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/manualDistributionUserCoupon', params, success, failed);
  },
  //优惠券使用情况
  'getUseResidenceUserCoupon': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/getUseResidenceUserCoupon', params, success, failed);
  },
  //优惠券结算
  'settleResidenceCoupon': function (_this, params, success, failed) {
    httpRequest(_this, '/weixin/settleResidenceCoupon', params, success, failed);
  },
  //58发房房态图列表
  'roomList58': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncBy58/roomList58', params, success, failed);
  },
  //58发房操作
  'publishRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncBy58/publishRoom', params, success, failed);
  },
  //58发房刷新
  'refreshRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncBy58/refreshRoom', params, success, failed);
  },
  //闲鱼授权信息
  'addIdleManager': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncByXY/addIdleManager', params, success, failed);
  },
  //获取闲鱼授权信息
  'getAliIdleManager': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncByXY/getAliIdleManager', params, success, failed);
  },
  //解除授权
  'delIdleManager': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncByXY/delIdleManager', params, success, failed);
  },
  //////////////////////微店管理接口 end/////////////////////

  //////////////////////管理模块接口 begin/////////////////////
  //1-菜单列表
  'menuList': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/menuList', params, success, failed);
  },
  //2-管理员列表
  'managerList': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/managerList', params, success, failed);
  },
  //3-角色列表
  'roleList': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/roleList', params, success, failed);
  },
  //4-新增管理员
  'createManager': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/createManager', params, success, failed);
  },
  //5-修改管理员
  'updateManager': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/updateManager', params, success, failed);
  },
  //6-修改管理员密码
  'changeManagerPassword': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/changeManagerPassword', params, success, failed);
  },
  //7-删除管理员
  'deleteManager': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/deleteManager', params, success, failed);
  },
  //8-激活管理员
  'activemanager': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/activeManager', params, success, failed);
  },
  //9-管理员名下房源列表
  'managerhouselist': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/managerHouseList', params, success, failed);
  },
  //10-分配房源
  'distributemanagerhouse': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/distributeManagerHouse', params, success, failed);
  },
  //11-权限交接
  'changekeeper': function (_this, params, success, failed) {
    httpRequest(_this, '/authority/changeKeeper', params, success, failed);
  },
  //12-导出经纪人
  'exportmanagerlist': function () {
    return preUrl + "/authority/exportManagerList";
  },
  //13-企业法人列表
  'enterpriselegalpersonlist': function (_this, params, success, failed) {
    httpRequest(_this, '/config/legalRepList', params, success, failed);
  },
  //14-新增修改企业法人
  'saveorupdateenterpriselegalperson': function (_this, params, success, failed) {
    httpRequest(_this, '/config/saveOrUpdateLegalRep', params, success, failed);
  },
  //15-法人认证
  'legalpersoncertification': function (_this, params, success, failed) {
    httpRequest(_this, '/config/authLegalRep', params, success, failed);
  },
  //16-企业列表
  'companylist': function (_this, params, success, failed) {
    httpRequest(_this, '/config/companyList', params, success, failed);
  },
  //17-新增修改企业
  'saveorupdatecompany': function (_this, params, success, failed) {
    httpRequest(_this, '/config/saveOrUpdateCompany', params, success, failed);
  },
  //18-企业认证
  'companycertification': function (_this, params, success, failed) {
    httpRequest(_this, '/config/authCompany', params, success, failed);
  },
  //19-生成印章
  'generateseal': function (_this, params, success, failed) {
    httpRequest(_this, '/config/generateCompanySeal', params, success, failed);
  },
  //20-查看电子合同
  'getDocument': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/getDocument', params, success, failed);
  },
  //21-系统设置列表
  'sysConfigList': function (_this, params, success, failed) {
    httpRequest(_this, '/config/sysConfigList', params, success, failed);
  },
  //21-修改系统设置
  'updateSystemConfig': function (_this, params, success, failed) {
    httpRequest(_this, '/config/updateSystemConfig', params, success, failed);
  },
  //////////////////////管理模块接口 end/////////////////////

  //////////////////////消息中心接口 begin/////////////////////
  //1-7天内消息列表
  'messageListIn7Days': function (_this, params, success, failed) {
    httpRequest(_this, '/message/messageListIn7Days', params, success, failed);
  },
  //////////////////////消息中心接口 end/////////////////////
  //修改密码
  //'doLogin': function (_this, params, success, failed) {
  //  httpRequest(_this, '/signin', params, success, failed);
  //},
  'doLogin': function (_this, params, success, failed) {
    httpRequest(_this, '/login', params, success, failed);
  },
  'doRegister': function (_this, params, success, failed) {
    httpRequest(_this, '/register', params, success, failed);
  },
  'doLogout': function (_this, params, success, failed) {
    httpRequest(_this, '/logout', params, success, failed);
  },
  'unLoginGetSMSCode': function (_this, params, success, failed) {
    httpRequest(_this, '/public/unLoginGetSMSCode', params, success, failed);
  },
  'validateAccountName': function (_this, params, success, failed) {
    httpRequest(_this, '/validateAccountName', params, success, failed);
  },
  'resetPassword': function (_this, params, success, failed) {
    httpRequest(_this, '/resetPassword', params, success, failed);
  },
  //业务员列表
  'assistantlist': function (_this, params, success, failed) {
    httpRequest(_this, '/user/assistantList', params, success, failed);
  },
  //房源推广
  'roomListXY': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncByXY/roomListXY', params, success, failed);
  },
  'publishRoomInIdle': function (_this, params, success, failed) {
    httpRequest(_this, '/apartmentRoomSyncByXY/publishRoomInIdle', params, success, failed);
  },
  'getLocalListBy58': function (_this, params, success, failed) {
    httpRequest(_this, '/realHouse/getLocalListBy58', params, success, failed);
  },
  'setLocalInfoBy58': function (_this, params, success, failed) {
    httpRequest(_this, '/realHouse/setLocalInfoBy58', params, success, failed);
  },
  //////////////////////门锁模块 begin/////////////////////
  //门锁状态
  'lockState': function (_this, params, success, failed) {
    httpRequest(_this, '/lock/lockState', params, success, failed);
  },
  //门锁信息
  'lockInfo': function (_this, params, success, failed) {
    httpRequest(_this, '/lock/lockInfo', params, success, failed);
  },
  //冻结/解冻
  'controlPassword': function (_this, params, success, failed) {
    httpRequest(_this, '/lock/controlPassword', params, success, failed);
  },
  //设置密码
  'setManagerPwd': function (_this, params, success, failed) {
    httpRequest(_this, '/lock/setManagerPwd', params, success, failed);
  },
  //发送临时密码
  'sendDynamicPassword': function (_this, params, success, failed) {
    httpRequest(_this, '/lock/sendDynamicPassword', params, success, failed);
  },
  //门锁操作记录
  'getLockOperateLogList': function (_this, params, success, failed) {
    httpRequest(_this, '/lock/getLockOperateLogList', params, success, failed);
  },
  //是否能获取临时密码
  'canSendDynamicPassword': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/canSendDynamicPassword', params, success, failed);
  },
  //////////////////////门禁模块 begin/////////////////////
  //添加门禁信息
  'addentranceguard': function (_this, params, success, failed) {
    httpRequest(_this, '/entranceGuard/addEntranceGuard', params, success, failed);
  },
  //添加/修改门禁信息
  'addormodifyentranceguard': function (_this, params, success, failed) {
    httpRequest(_this, '/entranceGuard/addOrModifyEntranceGuard', params, success, failed);
  },
  //门禁信息
  'entranceguardinfo': function (_this, params, success, failed) {
    httpRequest(_this, '/entranceGuard/entranceGuardInfo', params, success, failed);
  },
  //设置门禁
  'setentranceguard': function (_this, params, success, failed) {
    httpRequest(_this, '/entranceGuard/setEntranceGuard', params, success, failed);
  },
  //删除门禁
  'delentranceguard': function (_this, params, success, failed) {
    httpRequest(_this, '/entranceGuard/delEntranceGuard', params, success, failed);
  },

  //////////////////////资产模块 begin/////////////////////
  //1-房源信息列表
  'houseinfolist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/houseInfoList', params, success, failed);
  },
  //2-资产列表
  'assetlist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/houseAssetList', params, success, failed);
  },
  //3导出资产列表
  'exportassetlist': function () {
    return preUrl + "/asset/exportAssetList";
  },
  //4-保存资产草稿
  'saveassetdraft': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/saveAssetDraft', params, success, failed);
  },
  //5-新建/修改资产
  'saveorupdateasset': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/saveOrUpdateAsset', params, success, failed);
  },
  //6-资产详情
  'assetdetail': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/assetDetail', params, success, failed);
  },
  //导出房屋设施
  'downloadhousefacilities': function () {
    return preUrl + "/asset/downloadHouseFacilities";
  },
  //7-终止业主合同
  'endownercontract': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/endOwnerContract', params, success, failed);
  },
  //8-业主账单
  'ownerbill': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/ownerBillList', params, success, failed);
  },
  //9-业主账单记账
  'accountownerbill': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/accountOwnerBill', params, success, failed);
  },
  //10-修改账单记账凭证
  'modifyownerbillvoucherurl': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/modifyOwnerBillVoucherUrl', params, success, failed);
  },
  //10-开启业主账单自动支付
  'autopayownerbill': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/autoPayOwnerBill', params, success, failed);
  },
  //11导出业主账单
  'exportownerbill': function () {
    return preUrl + "/asset/exportOwnerBillList";
  },
  //10-审核资产
  'approveasset': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/approveAsset', params, success, failed);
  },
  //11导入已付业主账单
  'importpaidownerbill': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/importPaidOwnerBill', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //11导入开票记录
  'importassetinvoice': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/importAssetInvoice', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //财务报表
  //资产房源列表
  'assethouselist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/assetHouseList', params, success, failed);
    //return preUrl + "/report/getCashFlow";
  },
  //累计现金流列表
  'getcashflow': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getCashFlow', params, success, failed);
    //return preUrl + "/report/getCashFlow";
  },
  //预测累计净现金流总数
  'gettotaldata': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getTotalData', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //累计现金流明细列表
  'getcashflowdetail': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getCashFlowDetail', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //生成累计现金流报表
  'generatecashflowreport': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/generateCashFlowReport', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //上传累计现金流excel
  'uploadcashflowexcels': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/uploadCashFlowExcels', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //查询Excel上传状态
  'getcfexceluploadstatus': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getCFExcelUploadStatus', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //获取报表参数配置
  'getdict': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getDict', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //修改报表参数配置
  'modifydict': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/modifyDict', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //导出预测现金流
  'exportpredictcashflow': function () {
    return preUrl + "/asset/exportPredictCashFlowList";
  },
  //导出现金流报表
  'exportcashflow': function () {
    return preUrl + "/asset/exportCashFlowList";
  },
  //导出单套房源当前情况
  'exportCashFlowDetail': function () {
    return preUrl + "/asset/exportCashFlowDetail";
  },
  //导出月度报表
  'exportApartmentRoomMonthlyIncomeList': function () {
    return preUrl + "/residence/exportApartmentRoomMonthlyIncomeList";
  },
  //导入月度报表
  'importApartmentRoomMonthlyIncomeList': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/importApartmentRoomMonthlyIncomeList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //预测累计净现金流列表
  'predictcashflowlist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/predictCashFlowList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //获取房源资产列表(Pager)
  'gethouseassetfacilitieslist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getHouseAssetFacilitiesList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //收款人列表
  'getpayeelist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getPayeeList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //导出收款人列表
  'exportpayeelist': function (_this, params, success, failed) {
    return preUrl + "/asset/exportPayeeList";
  },
  //新增/修改收款人
  'saveorupdatepayee': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/saveOrUpdatePayee', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //收款人冻结/解冻
  'payeefreezeunfreeze': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/payeeFreezeUnfreeze', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //账户统计
  'accountstatistics': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/accountStatistics', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //交易明细
  'tradedetaillist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/tradeDetailList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //房源统计列表
  'gethousestatisticslist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/getHouseStatisticsList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //导出房源统计列表
  'exporthousestatisticslist': function () {
    return preUrl + "/asset/exportHouseStatisticsList";
  },
  //导出房源交易明细
  'exporthousetradedetail': function () {
    return preUrl + "/asset/exportHouseTradeDetail";
  },
  //下载交易明细
  'exportTradeDetailList': function () {
    return preUrl + "/asset/exportTradeDetailList";
  },
  //充值
  'accountrecharge': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/accountRecharge', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //提现
  'accountwithdraw': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/accountWithdraw', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //汇付银行列表
  'adapaybanklist': function (_this, params, success, failed) {
    httpRequest(_this, '/adapay/getBankList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //房源指导价列表
  'guidepricelist': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/guidePriceList', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //房源NPV测算
  'calculatenpv': function (_this, params, success, failed) {
    httpRequest(_this, '/asset/calculateNPV', params, success, failed);
    //return preUrl + "/report/exportApartmentPaymentRentBills";
  },
  //导出房源指导价列表
  'exportguidepricelist': function () {
    return preUrl + "/asset/exportGuidePriceList";
  },

  //////////////////////新合同模块接口 begin/////////////////////
  //1-创建/编辑租约
  'createTenementContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/createTenementContract', params, success, failed);
  },
  //2-租约详情
  'tenementNewContractDetail': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/tenementContractDetail', params, success, failed);
  },
  //3-无租约出租
  'leaseWithoutNewContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/leaseWithoutContract', params, success, failed);
  },
  //4-无租约退租
  'cancelLeaseWithoutNewContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/cancelLeaseWithoutContract', params, success, failed);
  },
  //5-退租
  'evictionNewContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/evictionContract', params, success, failed);
  },
  //6-续租
  'reletNewContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/reletContract', params, success, failed);
  },
  //7-换房
  'newExchangeRoom': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/exchangeRoom', params, success, failed);
  },
  //8-房间操作日志列表
  'newApartmentRoomTraceList': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/apartmentRoomTraceList', params, success, failed);
  },
  //废弃租约
  'newCloseContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/closeContract', params, success, failed);
  },
  //审核租约
  'approveNewContract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/approveContract', params, success, failed);
  },
  //标记房源可二次出租
  'setapartmentroomcanrent': function (_this, params, success, failed) {
    httpRequest(_this, '/residence/setApartmentRoomCanRent', params, success, failed);
  },
  //编辑租约
  'modifytenementcontract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/modifyTenementContract', params, success, failed);
  },
  //生成电子合同
  'generateelectroniccontract': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/generateElectronicContract', params, success, failed);
  },
  //重置审批状态
  'resetapproval': function (_this, params, success, failed) {
    httpRequest(_this, '/tenementContract/resetApproveState', params, success, failed);
  },
  //下载租约
  'exportTenementContractList': function () {
    return preUrl + "/tenementContract/exportTenementContractList";
  },
  //导出环比（分散式）
  'residenceRoomListChainRatioReport': function () {
    return preUrl + "/residence/residenceRoomListChainRatioReport";
  },
  //导出环比（分散式）
  'gettenementcontractcompare': function () {
    return preUrl + "/residence/tenementContractCompare";
  },

  //IRR使用记录
  'irrrecord': function (_this, params, success, failed) {
    httpRequest(_this, '/public/getIrrRecordList', params, success, failed);
  },
  //////////////////////新合同模块接口 end/////////////////////
};

function doLogin(_this, params, success, failed) {
  httpRequest(_this, '/login', params, success, failed);
}
function doLogout(_this, params, success, failed) {
  httpRequest(_this, '/logout', params, success, failed);
}
function operatorDetail(_this, params, success, failed) {
  httpRequest(_this, '/public/operatorDetail', params, success, failed);
}
export{doLogin,doLogout,operatorDetail};



// WEBPACK FOOTER //
// ./src/assets/js/http.js